import { enableProdMode } from '@angular/core';
// import { platformBrowser } from '@angular/platform-browser';

import { Chart, registerables } from 'chart.js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// O Chart.js 3 deixou de auto-registar controllers, escalas, elementos e plugins
// (no 2.x era automatico). Sem este registo qualquer grafico rebenta em runtime
// com `"<tipo>" is not a registered controller` — erro que nao e apanhado nem
// pelo build nem pelo lint. Registamos tudo de uma vez em vez de escolher por
// tipo de grafico, para nao partir ao adicionar um tipo novo. (claude)
Chart.register(...registerables);

if (environment.production) {
	enableProdMode();

	if (window) {
		window.console.log = function () { };
		window.console.warn = function () { };
		window.console.error = function () { };
		window.console.info = function () { };

		// window.console.log = function () { };
		// window.console.warn = function () { };
		// window.console.error = function () { };
		// window.console.info = function () { };
	}
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
